import React, { useState } from "react";
import { CustomLabel, HeaderDivider } from "../../utilities/utll";
import { Col, Row } from "reactstrap";
import { Button, Input, message } from "antd";
import { useVendorMasterStore } from "../../store/useVendorMasterStore";
import useTabsSystemStore from "../../store/RenderTabStore";

const ApproveReject = ({ checked }) => {
  const [approvalRemark, setApprovalRemark] = useState("");
  const { openTabs, addNewTab, setActiveTab, closeTab } = useTabsSystemStore();
  const { vendorDetailByGuid } = useVendorMasterStore();
  const { VendorType } = vendorDetailByGuid?.Vendor || {};

  const {
    approveVendor,
    rejectVendor,
    loading: actionLoading,
    checkBoxes,
  } = useVendorMasterStore();

  const SECTION_GROUPS = {
    "General Info": ["generalInfo", "registeredHo"],
    "Basic Data": ["taxDetails", "address"],
    "Commercial Terms": ["creditTerms", "paymentInsAndMethods"],
    "Trade Support Terms": [
      "totIncentives",
      "last3YearTurnover",
      "damageAndExpiry",
    ],
    Document: ["document"],
  };
  const getAffectedSections = () => {
    const uncheckedKeys = Object.entries(checkBoxes)
      .filter(([_, value]) => value === false)
      .map(([key]) => key);

    const affectedSections = [];

    Object.entries(SECTION_GROUPS).forEach(([sectionName, fields]) => {
      if (VendorType === "ZAEX" && sectionName === "Trade Support Terms") {
        return;
      }
      const hasUnchecked = fields.some((field) =>
        uncheckedKeys.includes(field),
      );

      if (hasUnchecked) {
        affectedSections.push(sectionName);
      }
    });

    return affectedSections;
  };

  const redirectToVendorProfile = () => {
    closeTab("new_registration");

    //  Check if vendor list tab already exists
    const isVendorListOpen = openTabs.some((tab) => tab.key === "form_35");
    if (!isVendorListOpen) {
      addNewTab([
        ...openTabs.filter((tab) => tab.key !== "new_registration"),
        {
          closable: true,
          key: "form_35",
          label: "Vendor List For Approve",
        },
      ]);
    }
    setActiveTab("form_35");
    localStorage.removeItem("vendorGUID");
    localStorage.removeItem("locationCode");
    localStorage.removeItem("submitted");
    localStorage.removeItem("showApprove");
  };
  return (
    <>
      <HeaderDivider title="Approve/Reject" />
      <Row style={{ marginTop: "0px" }}>
        <Col xl={12} lg={12}>
          <CustomLabel children={"Remarks"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Remark"
            size="medium"
            value={approvalRemark}
            onChange={(e) => setApprovalRemark(e.target.value)}
          />
        </Col>
        <Col xl={6} lg={6}>
          <Button
            color="cyan"
            variant="solid"
            style={{ marginRight: "0.5rem" }}
            type="primary"
            loading={actionLoading}
            onClick={async () => {
              if (!checked) {
                const sections = getAffectedSections();
                if (sections.length > 0) {
                  message.warning(
                    `Please check all fields in: ${sections.join(", ")}`,
                  );
                  return;
                }
              }
              if (!approvalRemark.trim()) {
                message.warning("Please enter approval remark");
                return;
              }

              try {
                const response = await approveVendor(approvalRemark);

                if (response?.IsSuccess) {
                  message.success("Vendor approved successfully");
                  redirectToVendorProfile();
                }
              } catch (error) {
                message.error(error.message || "Approval failed");
              }
            }}
          >
            Approve
          </Button>

          <Button
            color="purple"
            variant="solid"
            danger
            loading={actionLoading}
            onClick={async () => {
              if (!approvalRemark.trim()) {
                message.warning("Please enter rejection remark");
                return;
              }
              try {
                const response = await rejectVendor(approvalRemark);

                if (response?.IsSuccess) {
                  message.success("Vendor rejected successfully");
                  redirectToVendorProfile();
                }
              } catch (error) {
                message.error(error.message || "Rejection failed");
              }
            }}
          >
            Reject
          </Button>
        </Col>
      </Row>
    </>
  );
};
export default ApproveReject;
